import { AdminAssetsResponse, type AdminAsset } from '@diana/contracts';

import type { AdminApiClient } from '../../lib/api-client.js';

const ASSET_PAGE_SIZE = 100;

export async function loadAllAdminAssets(api: AdminApiClient): Promise<AdminAsset[]> {
  const assets: AdminAsset[] = [];
  const seenCursors = new Set<string>();
  let cursor: string | null = null;

  do {
    const cursorQuery: string = cursor ? `&cursor=${encodeURIComponent(cursor)}` : '';
    const response: ReturnType<typeof AdminAssetsResponse.parse> = await api.get(
      `/api/v1/admin/assets?limit=${ASSET_PAGE_SIZE}&archived=include${cursorQuery}`,
      AdminAssetsResponse,
    );
    assets.push(...response.assets);
    cursor = response.nextCursor;
    if (cursor) {
      if (seenCursors.has(cursor)) {
        throw new Error(`Asset pagination repeated cursor: ${cursor}`);
      }
      seenCursors.add(cursor);
    }
  } while (cursor);

  return assets;
}
